import { ISourceAuction } from "../../../services";

/**
 * Gets the auction ID from the auction name
 */
export const getAuctionIdFromName = (name: string, rowData: ISourceAuction[]): string => {
  // Find the auction with the given name
  const auction = rowData.find(
    (auction: ISourceAuction) => auction.name === name
  );
  return auction?.auctionId || "";
};

/**
 * Calculates the maximum height for the Returns panel based on window size
 */
export const calculateMaxHeight = (): number => {
  return window.innerHeight - 200;
};

/**
 * Calculates the maximum width for the Returns panel based on window size
 */
export const calculateMaxWidth = (): number => {
  return window.innerWidth;
};

/**
 * Calculates the total capacity being returned based on the quantities entered
 */
export const calculateTotalReturnCapacity = (quantities: Record<string, string>): number => {
  return Object.values(quantities).reduce((sum, val) => {
    const numValue = parseFloat(val);
    return sum + (isNaN(numValue) ? 0 : numValue);
  }, 0);
};

/**
 * Calculates appropriate panel height based on the number of rows in the grid
 * @param rowCount Number of rows in the source auctions grid
 * @param baseRowHeight Height per row in pixels
 * @param headerHeight Height of the header in pixels
 * @param footerHeight Height of the footer in pixels
 * @param bookSelectionHeight Height of the book selection area in pixels
 * @param minHeight Minimum height of the panel in pixels
 * @param maxHeight Maximum height of the panel in pixels
 * @returns Calculated panel height in pixels
 */
export const calculatePanelHeight = (
  rowCount: number,
  baseRowHeight: number = 48, // Default row height
  headerHeight: number = 60, // Default header height including margins
  footerHeight: number = 70, // Default footer height including margins
  bookSelectionHeight: number = 50, // Default book selection height including margins
  minHeight: number = 300, // Minimum height
  maxHeight: number = 700 // Maximum height
): number => {
  // Calculate table height based on row count plus header row
  const tableHeight = (rowCount + 1) * baseRowHeight;
  
  // Calculate total needed height
  const totalHeight = headerHeight + bookSelectionHeight + tableHeight + footerHeight + 50; // Add padding
  
  // Ensure the height is within bounds
  return Math.max(minHeight, Math.min(maxHeight, totalHeight));
};